import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer'
// import { applyMiddleware, createStore } from 'redux';
// import thunk, { ThunkMiddleware } from 'redux-thunk';
// import { devToolsEnhancer, composeWithDevTools } from 'redux-devtools-extension';
// import { TAppActionTypes } from 'types/actions/TAppActionTypes';


// Old middlewares, redux toolkit adds these by default
// const middlewares = [thunk as ThunkMiddleware<TRootState, TAppActionTypes>];

// Old redux store, pre redux-toolkit
// const store = createStore(
//     rootReducer,
//     composeWithDevTools(
//         applyMiddleware(...middlewares),
//         devToolsEnhancer({ trace: true }),
//     )
// )

const store = configureStore({
    devTools: process.env.NODE_ENV !== 'production',
    reducer: rootReducer
});


export type AppDispatch = typeof store.dispatch;
export default store;
